import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import { ReminderListItemDto } from './models/ReminderListItemDto';
import { RemindersCountersDto } from './models/RemindersCountersDto';
import { RemindersSearchCriteria } from './models/RemindersSearchCriteria';
import { ReminderViewModel } from './models/ReminderViewModel';

class RemindersService {
    public getList(criteria: RemindersSearchCriteria) {
        return Http.get<Paged<ReminderListItemDto>>('reminders', criteria);
    }

    public getCounters(criteria: RemindersSearchCriteria) {
        return Http.get<RemindersCountersDto>('reminders/counters', criteria);
    }

    public getById(id: string) {
        return Http.get<ReminderViewModel>('reminders/' + id);
    }

    public create(model: ReminderViewModel) {
        return Http.post<string>('reminders', model);
    }

    public update(model: ReminderViewModel) {
        return Http.put('reminders', model);
    }

    public remove(id: string) {
        return Http.put('reminders/deactivate', { id });
    }

    public finish(id: string) {
        return Http.put('reminders/finish', { id });
    }
    
}

export default new RemindersService();